import { Button } from 'antd';
import styled from 'styled-components';
import React, { useCallback, useMemo } from 'react';
import { CustomIcon, Widget } from 'datastake-daf/dist/components';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import Empty from './empty';
import Gallery from './gallery';
import DocumentsList from './documents-list';

const Style = styled.div`
  position: absolute;
  width: 300px;
  top: 20px;
  right: 40px;
  z-index: 500;
  display: flex;
  flex-direction: column;

  .main {
    flex: 1;
    transition: .4s max-height, .4s min-height;
    max-height: 585px;
    min-height: 585px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    &.main-hidden {
      max-height: 0px;
      min-height: 0px;
    }
  }

  &.amp-overview {
    top: var(--size-lg);
    right: var(--size-lg);

    .main {
      max-height: 370px;
      min-height: 370px;

      &.main-hidden {
        max-height: 0px;
        min-height: 0px;
      }
    } 
  }
`;

const Documentation = ({
  t = (s) => s,
  collapsed = false,
  setCollapsed = () => { },
  data = {},
  isSingleSource = false,
  isOwnData = false,
  locationId = '',
  mod = '',
  allSources = [],
  mode,
  className = '',
}) => {
  const isEmpty = useMemo(() => {
    if ((data.images && Array.isArray(data.images) && data.images.length > 0)
      || (data.documents && Array.isArray(data.documents) && data.documents.length > 0)) {
      return false;
    }
    return true;
  }, [data]);

  const findSource = useCallback((v) => {
    const source = allSources.find((s) => s.id === v);
    if (source) {
      return source.label;
    }
    return '';
  }, [allSources]);

  const images = useMemo(() => {
    if (data.images && Array.isArray(data.images)) {
      return data.images.slice(0, 10).map((i) => ({
        ...i,
        sourceName: !isSingleSource ? findSource(i.source) : null,
      }))
    }
    return [];
  }, [data, findSource, isSingleSource]);

  const documents = useMemo(() => {
    if (data.documents && Array.isArray(data.documents)) {
      return data.documents.map((i) => ({
        ...i,
        reporter: findSource(i.source),
      }))
    }
  }, [data, findSource]);
  const editUrl = isOwnData ? `/app/${mod}/edit/scl/${locationId}/documentation` : '';

  return (
    <Style
      className={formatClassname([
        isEmpty && 'is-empty',
        className,
      ])}
    >
      <Widget
        title={t('Related Documentation')}
        className="with-border-header widget-sm with-box-shadow"
        addedHeader={(
          <div className='flex-1 flex justify-content-end'>
            <Button onClick={() => setCollapsed((prev) => !prev)} className='more-btn'>
              <CustomIcon name="More" width={3} height={13} className="mt-1" />
            </Button>
          </div>
        )}>
        {!isEmpty ? (
          <div className={!collapsed ? 'main main-shown' : 'main main-hidden'}>
            {images.length > 0 ? (
              <Gallery
                images={images}
                className={className}
                t={t}
              />
            ) : (
              <Empty
                t={t}
                isOwnData={isOwnData && !mode === 'proxy'}
                editUrl={editUrl}
              />
            )}
            {documents.length > 0 ? (
              <>
                <DocumentsList
                  data={documents}
                  t={t}
                  isSingleSource={isSingleSource}
                />
              </>
            ) : (
              <Empty
                t={t}
                isOwnData={isOwnData && !mode === 'proxy'}
                type="DOCUMENTS"
                editUrl={editUrl}
              />
            )}
          </div>
        ) : (
          <div className={!collapsed ? 'main main-shown' : 'main main-hidden'}>
            <Empty
              isOwnData={isOwnData && !mode === 'proxy'}
              t={t}
              type="ALL"
              editUrl={editUrl}
            />
          </div>
        )}
      </Widget>
    </Style>
  );
};

export default Documentation;
